import lodash from "lodash";

export const onIFrameClickSelectAll = ({ refs, options, items, itemKey, getKey, rowKey, setKey, onSearch, afterSelect }) => {
    refs.iframe.contentWindow.onSearch = (param) => {
        const page = param?.page;
        const defaultOnSearch = () => {
            const value = items.filter((d) => d.isDelete !== true).map((d) => lodash.get(d, itemKey));
            if (value.length > 0) {
                page.where.push({ name: rowKey, type: "UUID", operator: "!in", value });
            }
        };
        if (onSearch) {
            onSearch(param);
        } else {
            defaultOnSearch();
        }
    };
    refs.iframe.contentWindow.onSelect = ({ rowSelection }) => {
        const itemsPush = [];
        rowSelection.selectedRows.forEach((row) => {
            const rowGet = getKey ? lodash.get(row, getKey) : row;
            let item = items.find((d) => lodash.get(d, itemKey) === lodash.get(row, rowKey));
            if (item) {
                item.isActive = true;
                item.isDelete = false;
                lodash.set(item, setKey, rowGet);
            } else {
                item = { isSave: true };
                if (setKey) {
                    lodash.set(item, setKey, rowGet);
                } else {
                    lodash.assign(item, rowGet);
                }
                itemsPush.push(item);
            }
        });
        items.push(...itemsPush);
        afterSelect?.({ rowSelection });
        options.bind.onCancel();
    };
};
